// @flow

import 'isomorphic-fetch'
import { checkHttpStatus, getApiHeaders, getApiBaseUrlWithOrg } from '../utils'
import { basicGet } from '../utils/api'
import { getErrorAction } from '../utils/actions'
import { getQuestFilterQuery } from '../utils/quests'
import type { Action } from '../types/actions/reviewqueue'
import type { APIError } from '../types'

export const FETCH_REVIEW_QUEUE_REQUEST = 'FETCH_REVIEW_QUEUE_REQUEST'
export const FETCH_REVIEW_QUEUE_SUCCESS = 'FETCH_REVIEW_QUEUE_SUCCESS'
export const FETCH_REVIEW_QUEUE_FAILURE = 'FETCH_REVIEW_QUEUE_FAILURE'
export const FETCH_REVIEW_QUEUE_COUNTS_REQUEST =
  'FETCH_REVIEW_QUEUE_COUNTS_REQUEST'
export const FETCH_REVIEW_QUEUE_COUNTS_SUCCESS =
  'FETCH_REVIEW_QUEUE_COUNTS_SUCCESS'
export const CLEAR_REVIEW_QUEUE_QUESTS = 'CLEAR_REVIEW_QUEUE_QUESTS'

export function fetchReviewQueueRequest(): Action {
  return {
    type: FETCH_REVIEW_QUEUE_REQUEST
  }
}

export function fetchReviewQueueSuccess(response: Object): Action {
  return {
    type: FETCH_REVIEW_QUEUE_SUCCESS,
    quests: response.compiled_quests,
    meta: response.meta
  }
}

export function fetchReviewQueueFailure(error: APIError): Action {
  return getErrorAction(FETCH_REVIEW_QUEUE_FAILURE, error)
}

export function fetchReviewQueueCountsRequest() {
  return {
    type: FETCH_REVIEW_QUEUE_COUNTS_REQUEST
  }
}

export function fetchReviewQueueCountsSuccess(counts) {
  return {
    type: FETCH_REVIEW_QUEUE_COUNTS_SUCCESS,
    payload: {
      counts
    }
  }
}

export function clearQuests() {
  return {
    type: CLEAR_REVIEW_QUEUE_QUESTS
  }
}

export function fetchReviewQueue(page, clearQuestsInState): Function {
  return async (dispatch, getState) => {
    const state = getState()
    const orgId = state.organization.orgId
    const query = getQuestFilterQuery(
      state.reviewqueuefilters,
      orgId,
      state.user.user
    )
    // needed for author certifications
    query.include_quest_authors = true

    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/compiled_quests/search`
    const sortOrder = state.reviewqueuefilters.sort_order
    // need to use the 'opposite' ordering for created_at since I'm showing the list in reverse order (by wait time, not recency)
    const waitTimeSortOrder = sortOrder === 'asc' ? 'desc' : 'asc'
    const orderParam =
      state.reviewqueuefilters.sort_type === 'created_at'
        ? [`created_at ${waitTimeSortOrder}`, `quest_priority ${sortOrder}`]
        : [`quest_priority ${sortOrder}`, `created_at ${waitTimeSortOrder}`]

    dispatch(fetchReviewQueueRequest())

    if (clearQuestsInState) {
      dispatch(clearQuests())
    }

    try {
      const response = checkHttpStatus(
        await fetch(url, {
          method: 'POST',
          headers: getApiHeaders(state),
          body: JSON.stringify({
            page,
            q: query,
            order: orderParam
          })
        })
      )
      const json = await response.json()
      dispatch(fetchReviewQueueSuccess(json))
    } catch (error) {
      dispatch(fetchReviewQueueFailure(error))
    }
  }
}

export function fetchReviewQueueCounts() {
  return (dispatch, getState) => {
    const state = getState()
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/compiled_quests/analytics`
    return basicGet(
      state,
      dispatch,
      url,
      fetchReviewQueueCountsRequest,
      fetchReviewQueueCountsSuccess
    )
  }
}



// WEBPACK FOOTER //
// ./src/actions/reviewqueue.js